<template>
  <div>
    <div v-if="!canViewFullDetails" class='mb-6 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700 block'>
      <a href='javascript:void(0)' @click="toFreeTrialPage" class='hover:underline'>Please register here for your free
        trial to see full company details!</a>
    </div>

    <div v-if='user && !isEditMode && !selectedCompanyEnriched.isServiceOnly' class=' mb-2 sm:mb-6 clearfix'>
      <div class="hidden sm:inline-block w-full">
        <button @click="navToBroadcasts"
                class='w-36 mr-2 inline-block text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0'>
          Broadcasts
        </button>
        <img v-if="screenWidth > 640"
          @click="openInitiateEscrow()"
          src="/img/escrow_button.png"
          alt="Escrow Button"
          title="Initiate Escrow.com deal"
          class="inline-block ml-6 sm:ml-0  h-9 w-40 sm:w-auto cursor-pointer"
        />

        <div class='sm:float-right'>
          <div class='grid grid-cols-2 sm:grid-cols-3 gap-0 sm:gap-2 mr-2'>
            <button v-if='!isInModal' @click="showRecommendModal" type="button"
                    class="w-36 inline-block text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0 mt-3">
              Recommend
            </button>
            <button v-if='!isInModal' @click='openComplaintModal' type="button"
                    class="w-40 sm:w-36 inline-block text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0 mt-3">
              File Complaint
            </button>
            <div v-if='isInModal' class="w-72 col-span-2"></div>
            <button v-if='!checkIfFavorite()' @click='setCompAsFavorite(true)' type="button"
                    class="w-36 inline-block text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0">
              <div class='grid grid-cols-3 gap-0' title="Click here to add this company to your favorites.">
                <div class='favorite_off cursor-pointer'></div>
                <div class=''>Favorite</div>
              </div>
            </button>
            <button v-else @click='setCompAsFavorite(false)' type="button"
                    class="w-36 inline-block text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0">
              <div class='grid grid-cols-3 gap-0'
                  title="This company is listed in your favorites. Click here to remove it.">
                <div class='favorite_on cursor-pointer'></div>
                <div class=''>Favorite</div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="block sm:hidden bg-white my-2 px-2 py-4 mt-4 shadow">
        <div class="flex gap-x-2 items-center justify-center">
          <div>
            <button @click="navToBroadcasts"
              class=' w-36 text-sm text-center text-red-700 font-bold border border-red-600 rounded py-2'>Broadcasts</button>
          </div>
          <img
            @click="openInitiateEscrow()"
            src="/img/escrow_button.png"
            alt="Escrow Button"
            title="Initiate Escrow.com deal"
            class="h-9 cursor-pointer"
          />
        </div>
        
        <div class="flex justify-end gap-x-4  mt-4 mx-1">
          <button class=" shadow rounded p-2 " @click="showRecommendModal">
            <svg width="26px" height="26px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" id="Editable-line" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="  M26.002,13H20V7.026C20,5.907,19.093,5,17.974,5c-0.615,0-1.198,0.28-1.582,0.76L9,15l0.001,0L9,15v10l3,2h12.473  c0.892,0,1.676-0.592,1.921-1.451l2.49-8.725C29.43,14.908,27.993,13,26.002,13z" fill="none" id="XMLID_5_" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><rect fill="none" height="14" id="XMLID_3_" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" width="6" x="3" y="13"/><circle cx="6" cy="23" id="XMLID_4_" r="1"/></svg>
          </button>
          <button class=" shadow rounded p-2 "  @click='openComplaintModal'>
            <svg fill="#000000" width="26px" height="26px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                <path d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-9.32 1221.49c-80.024 0-145.128 65.105-145.128 145.129 0 80.024 65.104 145.128 145.128 145.128 80.024 0 145.128-65.104 145.128-145.128 0-80.024-65.104-145.128-145.128-145.128Zm192.785-968.859h-385.57l93.901 851.327h197.768l93.901-851.327Z" fill-rule="evenodd"/>
            </svg>
          </button>
          <button class=" shadow rounded p-2" @click="setCompAsFavorite(!checkIfFavorite())">
            <svg width="26px" height="26px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" id="Editable-line" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="  M16.842,3.548l3.29,6.984c0.137,0.29,0.401,0.491,0.707,0.538l7.357,1.12c0.77,0.117,1.077,1.108,0.52,1.677l-5.324,5.436  c-0.221,0.226-0.322,0.551-0.27,0.87l1.257,7.676c0.131,0.803-0.673,1.416-1.362,1.036l-6.58-3.624c-0.273-0.151-0.6-0.151-0.873,0  l-6.58,3.624c-0.688,0.379-1.493-0.233-1.362-1.036l1.257-7.676c0.052-0.319-0.049-0.644-0.27-0.87l-5.324-5.436  c-0.557-0.569-0.25-1.56,0.52-1.677l7.357-1.12c0.306-0.047,0.57-0.248,0.707-0.538l3.29-6.984  C15.503,2.817,16.497,2.817,16.842,3.548z" :fill="checkIfFavorite() ? '#FACC15' : 'none'" id="XMLID_16_" :stroke="checkIfFavorite() ? '#FACC15' : '#000000'" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></svg>
          </button>
        </div>
      </div>




      
      <!-- <button @click="navToBroadcasts" class='mr-2 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700'>Show broadcasts of {{selectedCompanyEnriched.name}}</button> -->
      <!-- <button v-if='selectedCompany.doShowInventory' @click="navToParts" class='text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700'>Show parts of {{selectedCompany.name}}</button> -->
    </div>
     <!-- <img v-if="screenWidth <= 640"
          @click="openInitiateEscrow()"
          src="/img/escrow_button.png"
          alt="Escrow Button"
          title="Initiate Escrow.com deal"
          class="inline-block sm:ml-0  h-9 w-40 sm:w-auto cursor-pointer"
        /> -->

    <div v-if='isInModal' class="mt-1 mb-8 md:flex md:items-center md:justify-between">
      <h1 class="flex-1 min-w-0 font-bold mt-2 leading-7 text-gray-900 text-2xl sm:text-3xl leading-9 sm:truncate tracking-tight">
        <a href='javascript:void(0)' @click="toCompanyPage" class='hover:underline'>
          {{ selectedCompanyEnriched.name }}

          <svg class="hidden sm:inline-block ml-2 -mt-2" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
               fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
          </svg>
        </a>

        <div class="font-normal hidden sm:flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap hidden">
          <div v-if='selectedCompanyEnriched.website && selectedCompanyEnriched.website !== "-"'
               class="mt-1 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
            <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path
                  d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"/>
              <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"/>
            </svg>
            <a class='hover:underline' :href="selectedCompanyEnriched.website"
               target="_blank">{{ selectedCompanyEnriched.website }}</a>
          </div>
          <div class="mt-1 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
            <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clip-rule="evenodd"/>
            </svg>
            {{ selectedCompanyEnriched.country }}
          </div>
          <div v-if='canViewFullDetails' class="mt-1 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
            <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path
                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
            </svg>
            <a class='hover:underline' :href="selectedCompanyEnriched.telLink">{{ selectedCompanyEnriched.tel }}</a>
          </div>
        </div>

      </h1>

      <div class="mt-4 flex md:mt-0 md:ml-4">
        <div v-if='selectedCompanyEnriched.picUrl' :style='selectedCompanyEnriched.picCSS'
             @click="navCompanyWebsite(selectedCompanyEnriched.website)" class="cursor-pointer"></div>
        <!-- <button type="button" class="btn btn-primary">Recommend Company</button> -->
      </div>

    </div>

    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 lg:col-span-6 bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
          <!-- <div class='float-right' v-if='selectedCompanyEnriched.picUrl' :style='selectedCompanyEnriched.picCSS'></div> -->
          <h3 class="text-lg leading-6 font-medium text-gray-900">Company Details</h3>

          <div v-if='user && isEditMode' class='float-right -mt-8'>
            <div v-if='selectedCompanyEnriched.isTrusted' class='member_trusted cursor-pointer'
                 title="You are listed as a Trusted Member. Click here to download the Trusted Member Badge (PNG)"
                 @click="openBadgeForDownload('trusted')"></div>
            <div v-else-if='selectedCompanyEnriched.isGold' class='member_gold cursor-pointer'
                 title="You are listed as a Gold Member. Click here to download the Gold Member Badge (PNG)"
                 @click="openBadgeForDownload('gold')"></div>
            <div v-else-if='selectedCompanyEnriched.isDiamond' class='member_diamond cursor-pointer'
                 title="You are listed as a Diamond Member. Click here to download the Diamond Member Badge (PNG)"
                 @click="openBadgeForDownload('diamond')"></div>
            <div v-else class='member_normal cursor-pointer' title="Click here to download the TBS Member Badge (PNG)"
                 @click="openBadgeForDownload('normal')"></div>
          </div>
          <div v-else class='float-right -mt-8'>
            <div v-if='selectedCompanyEnriched.isTrusted' class='member_trusted'
                 title="This company is a 'Trusted Member'. Trusted members have been on www.TheBrokerSite.com for 3 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty."></div>
            <div v-if='selectedCompanyEnriched.isGold' class='member_gold'
                 title="This company is a 'Gold Member'. Gold members have been on www.TheBrokerSite.com for 10 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty."></div>
            <div v-if='selectedCompanyEnriched.isDiamond' class='member_diamond'
                 title="This company is a 'Diamond Member'. Diamond members have been on www.TheBrokerSite.com for 20 or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty."></div>
          </div>
        </div>
        <div>
          <dl class='mt-2 mb-8 max-h-120 overflow-y-auto'>
            <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm leading-5 font-medium text-gray-500">Name</dt>
              <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                {{ selectedCompanyEnriched.name }}
              </dd>
            </div>

            <div v-if='canViewFullDetails'>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Telephone</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">

                  <a v-if='!isEditMode' class='text-red-700'
                     :href="selectedCompanyEnriched.telLink">{{ selectedCompanyEnriched.tel }}</a>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.tel">
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Website</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>
                    <a v-if='selectedCompanyEnriched.website && selectedCompanyEnriched.website !== "-"'
                       class='text-red-700' :href="selectedCompanyEnriched.website"
                       target="_blank">{{ selectedCompanyEnriched.website }}</a>
                    <div v-else>-</div>
                  </div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.website"
                         @keydown.space="(event) => event.preventDefault()">
                </dd>
              </div>
              <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">{{ vatLabel }}</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  {{ selectedCompanyEnriched.vatNr }}
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Address</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <a v-if='!isEditMode && selectedCompanyEnriched.mapUrl' :href='selectedCompanyEnriched.mapUrl'
                     target='_blank' class='text-red-700'>{{ selectedCompanyEnriched.address }}</a>
                  <div v-else-if='!isEditMode && !selectedCompanyEnriched.mapUrl' target='_blank'>
                    {{ selectedCompanyEnriched.address }}
                  </div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.address">
                </dd>
              </div>
              <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Country</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  {{ selectedCompanyEnriched.country }}
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Shipping</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.shippingDetails }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.shippingDetails">
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Warranty Policy</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.warrantyPolicy }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.warrantyPolicy">
                </dd>
              </div>
            </div>

            <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm leading-5 font-medium text-gray-500">Company Description</dt>
              <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                <div v-if='!isEditMode' class="whitespace-pre-line">{{ selectedCompanyEnriched.description }}</div>
                <textarea v-else class='form-input block w-full' v-model="selectedCompanyEnriched.description"
                          rows="6"></textarea>
              </dd>
            </div>

            <div v-if='canViewFullDetails && !isEditMode' class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm leading-5 font-medium text-red-700 underline cursor-pointer"
                  @click='showBankInfo = !showBankInfo'>Bank Info
              </dt>
            </div>
            <div v-if='showBankInfo || isEditMode'>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Bank</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.bankCode }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.bankCode">
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">IBAN Number</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.ibanCode }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.ibanCode">
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Swift Code/BIC</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.swiftCode }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.swiftCode">
                </dd>
              </div>
              <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm leading-5 font-medium text-gray-500">Payment Method</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  <div v-if='!isEditMode'>{{ selectedCompanyEnriched.paymentMethod }}</div>
                  <input v-else class='form-input block w-full' v-model="selectedCompanyEnriched.paymentMethod">
                </dd>
              </div>
            </div>
          </dl>
          <div class='w-full clearfix -mt-4 mb-8'>
            <button v-if='isEditMode' @click='updateCompanyDetails' type="button"
                    class="btn btn-primary float-right mr-6">Update Company
            </button>
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6 bg-white shadow overflow-hidden sm:rounded-lg">

        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-900">Contact Details</h3>
        </div>

        <div class="grid grid-cols-12 gap-6 px-4 sm:px-6 mb-8 max-h-120 overflow-y-auto">
          <div v-for="(contact, index) in contactsEnriched" :key="index"
               class='col-span-12 sm:col-span-6 py-2 sm:gap-4 '>

            <div class='clearfix'>

              <div v-if='contact.profilePic'>
                <div v-if='contact.hasLargePic' @click='showLargePic(contact.id)'
                     class="w-12 h-12 rounded-full float-left mr-2 cursor-pointer ring-4" alt="profile picture"
                     :style="contact.picCSS"></div>
                <div v-else class="w-12 h-12 rounded-full float-left mr-2" alt="profile picture"
                     :style="contact.picCSS"></div>
              </div>
              <div v-else class="w-12 h-12 rounded-full float-left mr-2 cursor-pointer ring-4">
                <div v-if='isEditMode' @click="showProfilePicModal = true">
                  <svg class="h-12 w-12" stroke="none" fill="none" viewBox="2 2 16 16">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
                          fill="gray"/>
                  </svg>
                </div>
                <div v-else>
                  <svg class="h-12 w-12" stroke="none" fill="none" viewBox="2 2 16 16">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
                          fill="gray"/>
                  </svg>
                </div>
              </div>

              <div>
                <h4 class="mt-2 text-lg leading-6 font-medium text-gray-900 mb-0.5">{{ contact.name }}</h4>
                <div v-if='contact.label ==="Main contact"' class="float-left tag  bg-red-100 text-red-800">
                  {{ contact.label }}
                </div>
                <div v-else class="float-left tag bg-gray-100 text-gray-800">{{ contact.label }}</div>
                <a v-if="(!isEditMode || (user && contact && user.id !== contact.id))" href='javascript:void(0)'
                   @click='emitOpenModal(contact)' class='inline-block ml-2'>
                   <svg class="h-6 w-6 text-gray-400 float-left mr-2" fill="none" viewBox="0 0 24 24"
                       stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </a>

              </div>
            </div>


            <div v-if="!isEditMode || (user && contact && user.id !== contact.id)">

              <dl class="mt-2 text-sm leading-5 text-gray-500">
                <div v-if='contact.function' class='font-semibold'>
                  <dt class="sr-only">Function</dt>
                  <dl>{{ contact.function }}</dl>
                </div>
                <div class="mt-1" v-if='canViewFullDetails && contact.tel'>
                  <dt class="sr-only">Telephone</dt>
                  <dl><a :href='contact.telLink' class='text-red-700'>{{ contact.tel }}</a></dl>
                </div>
                <div class="float-left mr-2">
                  <a v-if="canViewFullDetails" :href='"whatsapp://send?phone=" + formatWhatsAppNumber(contact.tel)'>
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         viewBox="0 0 455.731 455.731" width="24" height="24" xml:space="preserve">
										<g>
											<rect x="0" y="0" style="fill:#1BD741;" width="455.731" height="455.731"/>
                      <g>
												<path style="fill:#FFFFFF;" d="M68.494,387.41l22.323-79.284c-14.355-24.387-21.913-52.134-21.913-80.638
													c0-87.765,71.402-159.167,159.167-159.167s159.166,71.402,159.166,159.167c0,87.765-71.401,159.167-159.166,159.167
													c-27.347,0-54.125-7-77.814-20.292L68.494,387.41z M154.437,337.406l4.872,2.975c20.654,12.609,44.432,19.274,68.762,19.274
													c72.877,0,132.166-59.29,132.166-132.167S300.948,95.321,228.071,95.321S95.904,154.611,95.904,227.488
													c0,25.393,7.217,50.052,20.869,71.311l3.281,5.109l-12.855,45.658L154.437,337.406z"/>
                        <path style="fill:#FFFFFF;" d="M183.359,153.407l-10.328-0.563c-3.244-0.177-6.426,0.907-8.878,3.037
													c-5.007,4.348-13.013,12.754-15.472,23.708c-3.667,16.333,2,36.333,16.667,56.333c14.667,20,42,52,90.333,65.667
													c15.575,4.404,27.827,1.435,37.28-4.612c7.487-4.789,12.648-12.476,14.508-21.166l1.649-7.702c0.524-2.448-0.719-4.932-2.993-5.98
													l-34.905-16.089c-2.266-1.044-4.953-0.384-6.477,1.591l-13.703,17.764c-1.035,1.342-2.807,1.874-4.407,1.312
													c-9.384-3.298-40.818-16.463-58.066-49.687c-0.748-1.441-0.562-3.19,0.499-4.419l13.096-15.15
													c1.338-1.547,1.676-3.722,0.872-5.602l-15.046-35.201C187.187,154.774,185.392,153.518,183.359,153.407z"/>
											</g>
										</g>
										</svg>
                  </a>
                </div>
                <div v-if='canViewFullDetails && contact.instantMessaging'>
                  <dt class="sr-only">Instant Message</dt>
                  <div v-if='contact.imName === "Teams"'>
                    <!-- <dl>
                      <a href="#" @click.prevent="startTeamsChat(contact.imValue)" class="teams-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2228.833 2073.333" width="24" height="24">
                          <path fill="#5059C9" d="M1554.637,777.5h575.713c54.391,0,98.483,44.092,98.483,98.483c0,0,0,0,0,0v524.398	c0,199.901-162.051,361.952-361.952,361.952h0h-1.711c-199.901,0.028-361.975-162-362.004-361.901c0-0.017,0-0.034,0-0.052V828.971	C1503.167,800.544,1526.211,777.5,1554.637,777.5L1554.637,777.5z"/>
                          <circle fill="#5059C9" cx="1943.75" cy="440.583" r="233.25"/>
                          <circle fill="#7B83EB" cx="1218.083" cy="336.917" r="336.917"/>
                          <path fill="#7B83EB" d="M1667.323,777.5H717.01c-53.743,1.33-96.257,45.931-95.01,99.676v598.105	c-7.505,322.519,247.657,590.16,570.167,598.053c322.51-7.893,577.671-275.534,570.167-598.053V877.176	C1763.579,823.431,1721.066,778.83,1667.323,777.5z"/>
                          <path opacity=".1" d="M1244,777.5v838.145c-0.258,38.435-23.549,72.964-59.09,87.598	c-11.316,4.787-23.478,7.254-35.765,7.257H667.613c-6.738-17.105-12.958-34.21-18.142-51.833	c-18.144-59.477-27.402-121.307-27.472-183.49V877.02c-1.246-53.659,41.198-98.19,94.855-99.52H1244z"/>
                          <path opacity=".2" d="M1192.167,777.5v889.978c-0.002,12.287-2.47,24.449-7.257,35.765	c-14.634,35.541-49.163,58.833-87.598,59.09H691.975c-8.812-17.105-17.105-34.21-24.362-51.833	c-7.257-17.623-12.958-34.21-18.142-51.833c-18.144-59.476-27.402-121.307-27.472-183.49V877.02	c-1.246-53.659,41.198-98.19,94.855-99.52H1192.167z"/>
                          <path opacity=".2" d="M1192.167,777.5v786.312c-0.395,52.223-42.632,94.46-94.855,94.855h-447.84	c-18.144-59.476-27.402-121.307-27.472-183.49V877.02c-1.246-53.659,41.198-98.19,94.855-99.52H1192.167z"/>
                          <path opacity=".2" d="M1140.333,777.5v786.312c-0.395,52.223-42.632,94.46-94.855,94.855H649.472	c-18.144-59.476-27.402-121.307-27.472-183.49V877.02c-1.246-53.659,41.198-98.19,94.855-99.52H1140.333z"/>
                          <path opacity=".1" d="M1244,509.522v163.275c-8.812,0.518-17.105,1.037-25.917,1.037	c-8.812,0-17.105-0.518-25.917-1.037c-17.496-1.161-34.848-3.937-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003	c-7.153-16.715-12.706-34.071-16.587-51.833h258.648C1201.449,414.866,1243.801,457.217,1244,509.522z"/>
                          <path opacity=".2" d="M1192.167,561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293	c-104.963-24.857-191.679-98.469-233.25-198.003h190.228C1149.616,466.699,1191.968,509.051,1192.167,561.355z"/>
                          <path opacity=".2" d="M1192.167,561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293	c-104.963-24.857-191.679-98.469-233.25-198.003h190.228C1149.616,466.699,1191.968,509.051,1192.167,561.355z"/>
                          <path opacity=".2" d="M1140.333,561.355v103.148c-104.963-24.857-191.679-98.469-233.25-198.003	h138.395C1097.783,466.699,1140.134,509.051,1140.333,561.355z"/>
                          <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="198.099" y1="1683.0726" x2="942.2344" y2="394.2607" gradientTransform="matrix(1 0 0 -1 0 2075.3333)">
                            <stop offset="0" stop-color="#5a62c3"/>
                            <stop offset=".5" stop-color="#4d55bd"/>
                            <stop offset="1" stop-color="#3940ab"/>
                          </linearGradient>
                          <path fill="url(#a)" d="M95.01,466.5h950.312c52.473,0,95.01,42.538,95.01,95.01v950.312c0,52.473-42.538,95.01-95.01,95.01	H95.01c-52.473,0-95.01-42.538-95.01-95.01V561.51C0,509.038,42.538,466.5,95.01,466.5z"/>
                          <path fill="#FFF" d="M820.211,828.193H630.241v517.297H509.211V828.193H320.123V727.844h500.088V828.193z"/>
                        </svg>
                      </a>
                    </dl> -->
                    <dl>{{ contact.instantMessaging }}</dl>
                  </div>
                  <div v-else>
                    <dl>{{ contact.instantMessaging }}</dl>
                  </div>
                </div>
                <div class="mt-1" v-if='user && contact.email && isEditMode'>
                  <dt class="sr-only">Primary Email</dt>
                  <dl>{{ contact.email }}</dl>
                </div>
              </dl>
            </div>
            <div v-else>
              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'>
                <div class='sm:col-span-6'>
                  <label class="block text-sm font-medium leading-5 text-gray-700">Contact Name</label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input v-model="contact.name"
                           class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  </div>
                </div>
              </div>

              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'>
                <div class='sm:col-span-6'>
                  <label class="block text-sm font-medium leading-5 text-gray-700">Contact Function</label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input v-model="contact.function"
                           class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  </div>
                </div>
              </div>

              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'>
                <div class='sm:col-span-6'>
                  <label class="block text-sm font-medium leading-5 text-gray-700 -mb-8">Instant Messaging</label>
                </div>
                <div class='sm:col-span-3'>
                  <div class="mt-1 rounded-md shadow-sm">
                    <select class="form-input block w-full" v-model='contact.imName'>
                      <option value="none">None</option>
                      <option value="Teams">Teams</option>
                      <option value="Trillian">Trillian</option>
                      <option value="Google Talk">Google Talk</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                <div class='sm:col-span-3'>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input v-model="contact.imValue"
                           class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                           placeholder='IM Handle'>
                  </div>
                </div>
              </div>

              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'>
                <div class='sm:col-span-6'>
                  <label class="block text-sm font-medium leading-5 text-gray-700">Contact Telephone</label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <input v-model="contact.tel"
                           class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  </div>
                </div>
              </div>

              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'
                v-if='isEditMode && user && user.isServiceOnly === 0'>
                <div class='sm:col-span-6'>
                  <div class="flex items-center">
                    <button type="button" @click='contact.rfqDisabled = !contact.rfqDisabled'
                            :class='{"bg-gray-200": contact.rfqDisabled, "bg-red-600": !contact.rfqDisabled}'
                            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            role="switch" aria-checked="false">
                      <span aria-hidden="true"
                            :class='{"translate-x-0 ": contact.rfqDisabled, "translate-x-5 ": !contact.rfqDisabled}'
                            class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                    </button>
                    <span class="ml-3">
											<span class="text-sm font-medium text-gray-900">Receive RFQ</span>
										</span>
                  </div>
                </div>
              </div>

              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6'
                v-if='isEditMode && user && user.isServiceOnly === 0'>
                <div class='sm:col-span-6'>
                  <div class="flex items-center">
                    <button type="button" @click='contact.possibleMatchesDisabled = !contact.possibleMatchesDisabled'
                            :class='{"bg-gray-200": contact.possibleMatchesDisabled, "bg-red-600": !contact.possibleMatchesDisabled}'
                            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            role="switch" aria-checked="false">
                      <span aria-hidden="true"
                            :class='{"translate-x-0 ": contact.possibleMatchesDisabled, "translate-x-5 ": !contact.possibleMatchesDisabled}'
                            class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                    </button>
                    <span class="ml-3">
											<span class="text-sm font-medium text-gray-900">Enable Possible Broadcast Matches</span>
										</span>
                  </div>
                </div>
              </div>


              <div class='mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6' v-if='isEditMode'>
                <div class='sm:col-span-6'>
                  <label class="block text-sm font-medium leading-5 text-gray-700">Primary email</label>
                  <div class="mt-1" v-if='user && contact.tel'>
                    <dl>{{ contact.email }}</dl>
                  </div>
                </div>
              </div>

              <!-- edit knoppen -->
              <div class='w-full clearfix -mt-4 relative mb-24' v-if='isEditMode'>
                <div class='float-right mt-8'>
                  <button @click='updateContactDetails' type="button" class="btn btn-primary">Update</button>
                  <button type="button" class="ml-3 btn btn-muted"
                          @click="showContactEditDropdown = !showContactEditDropdown">
                    More
                    <svg class="-mr-1 ml-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"/>
                    </svg>
                  </button>
                </div>
                <div v-if='showContactEditDropdown' v-on-clickaway="closeContactEditDropdown"
                     class="origin-top-right absolute mt-20 right-0 w-56 rounded-md shadow-lg">
                  <div class="rounded-md bg-white shadow-xs">
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <a href="javascript:void(0)" @click="doShowChangePasswordModal"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Change Password</a>
                      <a v-if="!user.enable2fa" href="javascript:void(0)" @click="toggle2fa"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Enable 2FA</a>
                      <a v-else href="javascript:void(0)" @click="toggle2fa"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Disable 2FA</a>
                      <a v-if="user && user.isServiceOnly===0" href="javascript:void(0)" @click="showBroadcastSettings"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Change Broadcast Settings</a>
                      <a href="javascript:void(0)" @click="showProfilePicModal = true"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Update Profile Picture</a>
                      <a v-if='profilePic' href="javascript:void(0)" @click="showConfirmDeletePicture = true"
                         class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                         role="menuitem">Remove Profile Picture</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-show="showChangePasswordModal" @submit="submitChangePassword" @cancel="showChangePasswordModal=false"
           header="Reset Password"
           affirmativeButtonLabel='Reset Password'
           :disableSubmit='passwordSubmitDisabled'
    >
      <template v-slot:body>
        <div>
          <dl class='mt-4 mb-4 sm:-ml-6 sm:-mr-6'>
            <div class=" py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
              <dt class="text-sm leading-9 font-medium text-gray-500">New Password</dt>
              <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                <password v-model="resetPasswordInput" @feedback="passwordFeedBack"
                          defaultClass='form-input block w-full' :toggle='true' @score='passwordScoreFeedback'/>
                <div class='text-blue-600' v-if='passwordSuggestion'>{{ passwordSuggestion }}</div>
              </dd>
            </div>
          </dl>
        </div>
      </template>
    </modal>

    <modal
      v-show="showInitiateEscrowModal"
      @cancel="showInitiateEscrowModal=false"
      :showAffirmativeButton="false"
      header="Start deal on Escrow.com"
    >
      <template v-slot:body>
        <p class="my-2 h3">
          You are about to start an escrow deal with {{ selectedCompanyEnriched.name }}. Please select your role
        </p>
        <div class="flex justify-center gap-3 w-full mt-4">
          <button
            @click="openEscrow('buyer')"
            class="border border-gray-300 bg-transparent text-gray-600 hover:text-gray-800 text-lg rounded px-8 py-2">
            Buyer
          </button>

          <button
            @click="openEscrow('seller')"
            class="border border-red-600 bg-red-600 hover:bg-red-700 text-lg text-white rounded px-8 py-2">
            Seller
          </button>
        </div>
      </template>
    </modal>


    <BroadcastSettings ref='BroadcastSettings'/>

    <!--		<modal-contact ref='contactModal' action='sendMailToContact'></modal-contact>-->

    <div v-if="selectedCompanyEnriched.isAttendingEBM && !isEditMode"
         class='mt-6 text-sm btn btn-muted text-blue-700 border-blue-700 hover:text-blue-700 block'>
      {{ selectedCompanyEnriched.name }} has attended the <a href="https://www.europeanbrokermeeting.com" target="_blank" class="text-blue-700 hover:text-blue-800" rel="noopener noreferrer">22nd European Broker Meeting in Portugal</a>.
    </div>

    <div v-if='user && !isInModal && !selectedCompanyEnriched.isServiceOnly' class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="flex px-4 py-5 border-b border-gray-200 sm:px-6">
          <!-- <div class='float-right' v-if='selectedCompany.picUrl' :style='selectedCompanyEnriched.picCSS'></div> -->
          <h3 class="text-lg flex-1 leading-8 font-medium text-gray-900">Recommendations</h3>

          <!-- <div class="mt-4  md:mt-0 md:ml-4" v-if='user && !isInModal && !isEditMode'>
            <button @click="showRecommendModal" type="button" class="mr-2 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700">Recommend this company</button>
          </div> -->

        </div>

        <div v-if="recommendations.length">
          <div v-for="(item, index) in recommendations" :key="index" class='px-6 py-5 mb-3 text-gray-700 text-sm '
               :class="{'bg-gray-50': index % 2}">

            <div class='float-right -mr-2' v-if='isEditMode'>
              <div v-if='item.status'><!-- approved -->
                <button @click="deleteRecommendation(item)"
                        class='mr-2 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700'>Delete
                </button>
              </div>
              <div v-else>
                <button @click="approveRecommendation(item)"
                        class='mr-2 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700'>Approve
                </button>
                <button @click="deleteRecommendation(item, true)"
                        class='mr-2 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700'>Decline
                </button>
              </div>
            </div>

            <div v-if='item.dateHuman && !isEditMode' class="float-right ml-12 uppercase text-gray-400 text-sm">
              {{ item.dateHuman }}
            </div>
            <div class='italic'>{{ item.body }}</div>
            <div class="font-semibold mt-1">{{ item.attr }}</div>
            <div v-if='item.dateHuman && isEditMode' class="uppercase text-gray-400 text-sm mt-1">{{ item.dateHuman }}
            </div>

          </div>
        </div>
        <div v-else class='px-6 py-5 mb-3 text-gray-700'>
          No recommendations yet. <span v-if='!isEditMode'>Be the first by clicking on the Recommend button at the top of this page!</span>
        </div>
      </div>
    </div>

    <modal-contact ref='contactModal' action='sendMailToContact'  @message-sent="checkMessageRateLimit"></modal-contact>
    
    <modal v-show="isRecommendModalVisible" @cancel="closeRecommendModal" @submit='submitRecommendation'
           header="Write a recommendation for this member"
           affirmativeButtonLabel='Submit'>
      <template v-slot:body>
        Recommendations will be reviewed by this member before being published
        <div class="mt-3 relative rounded-md shadow-sm">
          <textarea v-model="recommendationText" @keyup="checkRecommendationValid"
                    class="form-input block w-full sm:text-sm sm:leading-5"></textarea>
          <div v-if="isRecommendationInvalid"
               class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
        </div>
        <p v-if="isRecommendationInvalid" class="mt-2 text-sm text-red-600" id="email-error">Your recommendation must be
          at least 30 characters long.</p>
      </template>
    </modal>

    <modal v-show="is2faModalVisible" @cancel="close2faModal"
           :header="user && user.enable2fa ? 'Disable 2FA' : 'Enable 2FA'"
           affirmativeButtonLabel="Verify Code"
           :showAffirmativeButton="showVerification"
           @submit="verify2faCode">
      <template v-slot:body>
        <div v-if="show2faDescription">
          <p class="mb-4 text-sm text-gray-600">To enable 2-Factor Authentication (2FA), you will need to have a 2FA app (Google Authenticator, Authy, or Microsoft Authenticator) installed on your phone. <br><br>
            If you have your preferred authenticator installed, please scan this QR code with your authenticator app:</p>
          <div class="flex justify-center">
            <img v-if="qrCode" :src="qrCode" alt="QR Code for 2FA" />
            <div v-else>Loading QR code...</div>
          </div>
          <p class="mt-4 mb-4 text-sm text-gray-600 text-center">
            <a href="javascript:void(0)" @click="proceedToVerification" class="text-red-700 hover:underline cursor-pointer">
              I've scanned the QR code - Verify my setup
            </a>
          </p>
          <p class="mt-4 mb-4 text-sm text-gray-600 text-center">
            <a href="javascript:void(0)" @click="show2faDescription = false" class="text-red-700 hover:underline cursor-pointer">
              What is 2-Factor Authentication (2FA)?
            </a>
          </p>
        </div>
        <div v-else-if="showVerification">
          <p class="mb-4 text-sm text-gray-600">
            <span v-if="user.enable2fa">
              <strong>WARNING:<br>Disabling 2-Factor Authentication (2FA) will make your account more vulnerable to unauthorized access!</strong><br>Please consider this carefully before proceeding.<br><br>
              To disable 2FA, please enter the 6-digit code shown in your authenticator app:
            </span>
            <span v-else>
              To complete the 2FA setup, please enter the 6-digit code shown in your authenticator app:
            </span>
          </p>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              ref="verificationInput"
              v-model="verificationCode"
              type="text"
              maxlength="6"
              pattern="[0-9]*"
              inputmode="numeric"
              class="form-input block w-full sm:text-sm sm:leading-5"
              placeholder="Enter 6-digit code"
            />
          </div>
          <p v-if="verificationError" class="mt-2 text-sm text-red-600">
            {{ verificationError }}
          </p>
        </div>
        <div v-else>
          <p class="mb-4 text-sm text-gray-600"><br><strong>What is 2-Factor Authentication (2FA)?</strong><br><br>2-Factor Authentication (2FA) is a security feature that requires two forms of identification to access your account. This adds an extra layer of security to your account by requiring not only your password but also a one-time code generated by your authenticator app.<br>
            This makes it much more difficult for unauthorized users to access your account.<br><br>Enabling 2FA is not required, but we <strong>highly recommend</strong> enabling it to increase the security of your account.</p>
          <p class="mt-4 mb-4 text-sm text-gray-600 text-center">
            <a href="javascript:void(0)" @click="show2faDescription = true" class="text-red-700 hover:underline cursor-pointer">
              Scan my QR Code
            </a>
          </p>
        </div>
      </template>
    </modal>

    <modal v-show="showProfilePicModal" @submit="uploadPictureAndCloseModal" @cancel="showProfilePicModal = false"
           header="Change your profile picture"
           :disableSubmit="!hasImage"
           affirmativeButtonLabel='Upload picture'>
      <template v-slot:body>
        <div class='mt-8'>
          <image-uploader
              :debug="1"
              :maxWidth="400"
              :maxHeight="400"
              :quality="0.9"
              :preview=true
              :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
              accept=".jpg, .jpeg, .png"
              @input="setImage"
          ></image-uploader>
        </div>
      </template>
    </modal>

    <modal v-show="showLargePicModal" @submit="showLargePicModal = false" @cancel="showLargePicModal = false"
           :doSkipHeader="true"
           :doSkipCancel="true"
           affirmativeButtonLabel='Close'>
      <template v-slot:body>
        <div class='mt-8'>
          <img v-if='profilePicLarge' :src='profilePicLarge'/>
          <div v-else>No picture available</div>
        </div>
      </template>
    </modal>

    <modal v-show="showConfirmDeletePicture" @submit="removePictureAndCloseModal()"
           @cancel="showConfirmDeletePicture = false"
           header="Confirm delete"
           affirmativeButtonLabel='Yes, Delete'>
      <template v-slot:body>
        <div>Are you sure you want to delete this picture?</div>
      </template>
    </modal>


    <modal v-if='user' v-show="showMessageRateLimitModal" @submit="showMessageRateLimitModal = false"
      header="Message Limit Reached"
      :doSkipCancel="true"
      affirmativeButtonLabel='Close'>
      <template v-slot:body>
        <div class=" mt-4 text-center bg-red-300x">
         <div class="flex flex-col sm:flex-row items-center sm:items-start justify-center text-center sm:text-left gap-4 sm:gap-3">
            <!-- Icon -->
            <div class="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-yellow-100">
              <svg
                class="w-8 h-8 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M10.29 3.86l-7.82 13a2 2 0 001.71 3h15.64a2 2 0 001.71-3l-7.82-13a2 2 0 00-3.42 0z"
                />
              </svg>
            </div>

            <!-- Description -->
            <p class="mt-0 sm:mt-2 text-sm text-gray-500 max-w-md">
              You've reached the maximum of
              <span class="font-semibold text-gray-700">5 messages</span>
              within a 1-hour period.  You can send another message in <span class="font-semibold text-gray-900">
              {{ messageRateLimitCountdown }}
            </span>.
            </p>
          </div>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import _ from 'lodash';
// import Password from 'vue-password-strength-meter'
import { mixin as clickaway } from 'vue-clickaway';
import Modal from "./modal"
import BroadcastSettings from './BroadcastSettings'
import ModalContact from './ModalContact.vue'
import resetPassword from './mixins/resetPassword'
import eventBus from '../utils/eventBus'

export default {
  name: 'CompanyBody',
  props: ['selectedCompanyEnriched', 'contactsEnriched', 'isInModal', 'isEditMode'],
  mixins: [clickaway, resetPassword],
  components: {
    Modal,
    // Password,
    BroadcastSettings,
    ModalContact,
  },  
  data() {
    return {
      showBankInfo: false,
      isRecommendModalVisible: false,
      isRecommendationInvalid: true,
      is2faModalVisible: false,
      qrCode: "",
      recommendationText: "",
      showProfilePicModal: false,
      showConfirmDeletePicture: false,
      picBase64: null,
      hasImage: false, //selected in image upload widget?
      showLargePicModal: false,
      profilePicLarge: null,
      isFavorite: false,
      currentRoute: null,
      show2faDescription: true,
      showVerification: false,
      verificationCode: '',
      verificationError: '',
      showInitiateEscrowModal: false,
      screenWidth: window.innerWidth, 
      canSendMessage: true,
      rateLimitTimer: null,
      messageRateLimitCountdown: '00:00',
      showMessageRateLimitModal: false,
      messageRateLimitTimer: null
    }
  },
  mounted() {
    this.currentRoute = this.$route.path
  },
  beforeDestroy() {
    clearInterval(this.rateLimitTimer)
  },
  async created() {
      await this.checkMessageRateLimit();
      if (this.$route.query.profilePrompt === "1" && this.$route.name == "profile") {
        await this.updateAiMatchingProfilePrompt();
      }
  },
  watch: {
    showVerification(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.verificationInput) {
            this.$refs.verificationInput.focus();
          }
        });
      }
    }
  },
  methods: {
    ...mapActions(["updateCompany", "updateContact", 'recommendCompany', 'deleteRec', 'approveRec', "uploadPicture", 'removePicture', 'setAsFavorite']),
       
    openEscrow(role) {
      if (typeof window === 'undefined') return;
      const url = this.$router.resolve({
        path: `/escrow?companyId=${this.selectedCompanyEnriched.id}&role=${role}`
      }).href;
      window.open(url, '_blank');
    },
    openInitiateEscrow() {
      this.showInitiateEscrowModal = true
    },
    generateTeamsLinks(email, prefilledMessage = '') {
      const encodedEmail = encodeURIComponent(email);
      const encodedMessage = encodeURIComponent(prefilledMessage);
      return {
        chat: {
          web: `https://teams.microsoft.com/l/chat/0/0?users=${encodedEmail}&message=${encodedMessage}`,
          app: `msteams:/l/chat/0/0?users=${encodedEmail}&message=${encodedMessage}`
        }
      };
    },
    openTeamsLink(appLink, webLink) {
      // Try opening the app
      window.location.href = appLink;
      
      // If app fails to open, fall back to web after delay
      setTimeout(() => {
        if (!document.hidden) {
          window.open(webLink, '_blank');
        }
      }, 500);
    },
    startTeamsChat(imValue) {
      const links = this.generateTeamsLinks(imValue, '');
      this.openTeamsLink(links.chat.app, links.chat.web);
    },
    emitOpenModal(contact) {

      if (!this.canSendMessage) {
        this.showMessageRateLimitModal = true;
        return;
      }

      this.currentRoute == '/services'
        ? this.$emit('openModal', contact)
        : this.user && this.$refs.contactModal.openSendMessageModal(contact);
    },
    checkIfService() {
      console.log(this.currentRoute)
      if (this.currentRoute == '/services') {
        return true
      } else {
        return false
      }
    },
    navToBroadcasts() {
      this.$router.push({name: 'broadcasts', query: {companyId: this.selectedCompanyEnriched.id}})
    },
    toCompanyPage() {
      const newRoute = {path: `/companies/${this.selectedCompanyEnriched.id}`} // had to add the leading slash here to make sure the path is resolved correctly. Otherwise a trailing slash would mess up the path.
      if (this.route.name === "services") {
        newRoute.query = {iS: "1"}
      }
      this.$router.push(newRoute);
    },
    toFreeTrialPage() {
      this.$router.push({name: `freeTrial`});
    },
    openBadgeForDownload(badgeType) {
      // console.log(badgeType)
      window.open('/media/img/' + badgeType + ".png")
    },
    async updateCompanyDetails() {
      // const selectedCompanyDTO = _.omit(this.selectedCompanyEnriched, ['contacts', 'recommendations', 'picUrl', 'telLink', 'picCSS', 'isGold', 'isTrusted', 'username', 'lat', 'lng', 'doShowInventory', 'isAttendingEBM', 'name', 'country' ])
      const selectedCompanyDTO = _.pick(this.selectedCompanyEnriched, ['id', 'tel', 'website', 'address', 'shippingDetails', 'description', 'bankCode', 'ibanCode', 'swiftCode', 'paymentMethod', 'warrantyPolicy'])

      const resp = await this.updateCompany(selectedCompanyDTO);

      if (resp.data.status !== 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: "Company wasn't updated. Please try again. <br/> If the problem persists please contact The Broker Site",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Company profile succesfully updated"
        })
      }
    },
    async updateContactDetails() {

      const contactDTO = _.pick(_.find(this.contactsEnriched, {id: this.user.id}), ['id', 'tel', 'function', 'name', 'imName', 'imValue', 'rfqDisabled', 'possibleMatchesDisabled']);

      const resp = await this.updateContact(contactDTO);

      if (resp.data.status !== 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: "Contact wasn't updated. Please try again. <br/> If the problem persists please contact The Broker Site",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Contact succesfully updated",

        })
      }
    },

    checkIfFavorite() {
      return this.selectedCompanyEnriched.misc ? this.selectedCompanyEnriched.misc[0].isFavorite : false
    },

    async setCompAsFavorite(sw) {
      const favoriteDTO = {'companyId': this.selectedCompanyEnriched.id, 'byContactId': this.user.id, 'action': sw};
      const resp = await this.setAsFavorite(favoriteDTO)
      let bodyMsgFail = ''
      let bodyMsgSuccess = ''

      if (sw) {
        bodyMsgFail = "This Company was not added as favorite. Please try again. <br/> If the problem persists please contact The Broker Site"
        bodyMsgSuccess = "This Company was saved in your Favorites."
        // this.isFavorite = true;
        this.selectedCompanyEnriched.misc[0].isFavorite = true
      } else {
        bodyMsgFail = "This Company was not removed from your favorites. Please try again. <br/> If the problem persists please contact The Broker Site"
        bodyMsgSuccess = "This Company was removed from your Favorites."
        // this.isFavorite = false;
        this.selectedCompanyEnriched.misc[0].isFavorite = false
      }

      if (resp.data.status !== 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: bodyMsgFail,
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: bodyMsgSuccess,

        })
      }
    },

    closeContactEditDropdown() {
      this.showContactEditDropdown = false;
    },
    showBroadcastSettings() {
      this.$refs.BroadcastSettings.$emit("showModal")
      this.showContactEditDropdown = false;
    },
    checkRecommendationValid() {
      this.isRecommendationInvalid = this.recommendationText.length < 30
    },
    showRecommendModal() {
      this.isRecommendModalVisible = true;
      this.isRecommendationInvalid = false; //reset validation
    },
    closeRecommendModal() {
      this.isRecommendModalVisible = false;
    },
    close2faModal() {
      // Close the modal immediately without changing content
      this.is2faModalVisible = false;
      
      // Reset modal state after a short delay to ensure modal is closed
      setTimeout(() => {
        this.show2faDescription = true;
        this.showVerification = false;
        this.verificationCode = '';
        this.verificationError = '';
      }, 300); // Adjust timing based on your modal's close animation duration
    },
    show2faModal() {
      return new Promise((resolve) => {
        this.$http.post('/api/companies/generate2faSecret')
          .then(response => {
            if (response.data.status === 200) {
              const secret = response.data.secret;
              const otpauthUrl = `otpauth://totp/TheBrokerSite:${this.user.email}?secret=${secret}&issuer=TheBrokerSite`;
              this.qrCode = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(otpauthUrl)}`;
              this.is2faModalVisible = true;
              resolve();
            } else {
              throw new Error('Failed to generate 2FA secret');
            }
          })
          .catch(error => {
            console.error('Error generating 2FA secret:', error);
            // Handle error appropriately
            resolve();
          });
      });
    },
    async deleteRecommendation(item, isDecline = false) {
      try {
        const resp = await this.deleteRec({id: item.id})
        eventBus.$emit('updateProfile', resp.data)

        eventBus.$emit("createSnackbar", {
          type: "success",
          title: `Recommendation ${isDecline ? 'declined' : 'deleted'}`,
        })
        // this.$router.go(this.$router.currentRoute)
      } catch (err) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: `Recommendation could not be ${isDecline ? 'declined' : 'deleted'}`,
          body: "Please try again. If this occur keeps occuring, please contact The Broker Site",
          timeoutInMS: 5000,
        })
      }
    },
    async approveRecommendation(item) {
      try {
        const resp = await this.approveRec({id: item.id})
        eventBus.$emit('updateProfile', resp.data)

        eventBus.$emit("createSnackbar", {
          type: "success",
          title: `Recommendation approved`,
        })
        // this.$router.go(this.$router.currentRoute)
      } catch (err) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: `Recommendation could not be approved`,
          body: "Please try again. If this occur keeps occuring, please contact The Broker Site",
          timeoutInMS: 5000,
        })
      }
    },
    async submitRecommendation() {
      if (this.recommendationText.length < 30) return;
      try {
        const resp = await this.recommendCompany({
          companyId: this.selectedCompanyEnriched.id,
          text: this.recommendationText,
        })
        if (resp.data.status !== 200) throw resp.data

        this.isRecommendModalVisible = false;
        this.recommendationText = ""

        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Recommendation sent",
        })

      } catch (err) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Recommendation could not be sent",
          body: "Please try again. If this occur keeps occuring, please contact The Broker Site",
          timeoutInMS: 5000,
        })
      }

    },
    setImage(picBase64) {
      this.hasImage = true
      this.picBase64 = picBase64
    },
    async removePictureAndCloseModal() {
      try {
        const resp = await this.removePicture()
        if (resp.data.status !== 200) throw resp
      } catch (err) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Picture could not be deleted",
          body: "Please try again. If this occur keeps occuring, please contact The Broker Site",
          timeoutInMS: 5000,
        })
      }
      this.showConfirmDeletePicture = false
      this.$router.go(this.$router.currentRoute)
    },
    async uploadPictureAndCloseModal() {
      try {
        const resp = await this.uploadPicture({picture: this.picBase64})
        if (resp.data.status !== 200) throw resp

        this.closeUploadPictureModal()
        this.$router.go(this.$router.currentRoute)

      } catch (err) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Profile Picture could not be uploaded",
          body: "Please try again. If this occur keeps occurring, please contact The Broker Site",
          timeoutInMS: 5000,
        })
      }

    },
    closeUploadPictureModal() {
      this.picBase64 = null;
      this.showProfilePicModal = false
    },
    async showLargePic(id) {
      const resp = await this.$http.get(`/api/companies/fetchLargePicture/${id}`)
      this.profilePicLarge = resp.data.profilePicLarge || null
      this.showLargePicModal = true;
    },
    openComplaintModal() {
      this.$parent.$parent.openComplaintModal()
    },
    navCompanyWebsite(strUrl) {
      const a = document.createElement('a');
      a.href = strUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    formatWhatsAppNumber(phoneString) {
      const firstPhoneString = (phoneString || '').split(',')[0].trim()
      const cleanedString = firstPhoneString.replace(/[^\d]/g, '')
      return cleanedString
    },
    toggle2fa() {
      if (this.user.enable2fa) {
        // Show 2FA verification modal for disabling
        this.showDisable2faModal()
        this.closeContactEditDropdown()
      } else {
        this.show2faModal()
        this.closeContactEditDropdown()
      }
    },
    showDisable2faModal() {
      this.is2faModalVisible = true
      this.show2faDescription = false
      this.showVerification = true
      this.verificationCode = ''
      this.verificationError = ''
    },
    async verify2faCode() {
      this.verificationError = '';
      if (!this.verificationCode || this.verificationCode.length !== 6) {
        this.verificationError = 'Please enter a valid 6-digit code';
        return;
      }

      try {
        // Check if we're enabling or disabling 2FA
        if (this.user.enable2fa) {
          // Disabling 2FA - verify code first, then disable
          const response = await this.$http.post('/api/companies/verify2faForDisable', {
            code: this.verificationCode
          });

          if (response.data.status === 200) {
            // Code verified, now disable 2FA
            const disableResponse = await this.$http.post('/api/companies/disable2fa', {});
            if (disableResponse.data.status === 200) {
              this.user.enable2fa = false;
              this.close2faModal();
              eventBus.$emit("createSnackbar", {
                type: "success",
                title: "2FA Successfully Disabled",
                body: "Two-factor authentication has been disabled for your account",
              });
            }
          } else {
            this.verificationError = 'Invalid code. Please try again.';
          }
        } else {
          // Enabling 2FA - existing logic
          const response = await this.$http.post('/api/companies/verify2fa', {
            code: this.verificationCode
          });

          if (response.data.status === 200) {
            this.user.enable2fa = true;
            this.close2faModal();
            eventBus.$emit("createSnackbar", {
              type: "success",
              title: "2FA Successfully Enabled",
              body: "Two-factor authentication has been enabled for your account",
            });
          } else {
            this.verificationError = 'Invalid code. Please try again.';
          }
        }
      } catch (error) {
        this.verificationError = 'Failed to verify code. Please try again.';
        console.error('Error verifying 2FA:', error);
      }
    },
    proceedToVerification() {
      this.showVerification = true;
      this.show2faDescription = false;
    },
    navToEscrow(role) {
      return window.open(this.$router.resolve({path: `/escrow?companyId=${this.selectedCompanyEnriched.id}&role=${role}`}).href, '_blank');
    },
    async checkMessageRateLimit() {
      try {
        const resp = await this.$http.get('/api/mail/message-rate-limit')

        const fifthMessageTimestamp = resp.data.fifthMessageTimestamp

        // Fewer than 5 messages
        if (!fifthMessageTimestamp) {
          this.canSendMessage = true
          return
        }

        const expiresAt = fifthMessageTimestamp + (60 * 60 * 1000)
        const remaining = expiresAt - Date.now()

        // Limit already expired
        if (remaining <= 0) {
          this.canSendMessage = true
          return
        }

        this.canSendMessage = false

        // Start the live countdown
        this.startMessageRateLimitCountdown(fifthMessageTimestamp)

      } catch (error) {
        console.error('Failed to check message rate limit:', error)
      }
    },
    startMessageRateLimitCountdown(timestamp) {
      clearInterval(this.rateLimitTimer)

      const expiresAt = timestamp + (60 * 60 * 1000)

      const updateCountdown = () => {
        const remaining = Math.max(0, expiresAt - Date.now())

        const totalSeconds = Math.floor(remaining / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60

        this.messageRateLimitCountdown =
          `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

        if (remaining <= 0) {
          clearInterval(this.rateLimitTimer)
          this.canSendMessage = true
        }
      }

      updateCountdown()

      this.rateLimitTimer = setInterval(updateCountdown, 1000)
    },
    async updateAiMatchingProfilePrompt() {
      await this.$http.put(
        "/api/companies/ai-matching-profile-prompt"
      );
    }
  },
  computed: {
    ...mapState(["user", 'profilePic', 'route']),
    recommendations() {
      return _.map(this.selectedCompanyEnriched.recommendations, rec => ({
        id: rec.id,
        body: rec.description,
        attr: `-- ${rec.contactName} from ${rec.companyName}`,
        dateHuman: new Date(rec.dt).toLocaleString(),
        status: rec.status,
      }))
    },
    vatLabel() {
      return this.selectedCompanyEnriched.country === 'UK' ? "EORI" : "VAT"
    },
    isFromServicesPage() {
      const servicesRoutes = ['services', 'serviceCategory', 'serviceCompany'];
      return servicesRoutes.includes(this.route?.name);
    },
    canViewFullDetails() {
      if (this.user) return true;
      if (!this.selectedCompanyEnriched || this.selectedCompanyEnriched.hideServiceDetails) {
        return false;
      }
      // Guests: full details only on services hub / category / SEO company pages — never on /companies
      if (this.isFromServicesPage && this.selectedCompanyEnriched.isService) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.member_normal {
  width: 40px;
  height: 40px;
  background: url("../assets/normal.png");
  background-size: cover;
}

.member_trusted {
  width: 40px;
  height: 40px;
  background: url("../assets/trusted.png");
  background-size: cover;
}

.member_gold {
  width: 40px;
  height: 40px;
  background: url("../assets/gold.png");
  background-size: cover;
}

.member_diamond {
  width: 40px;
  height: 40px;
  background: url("../assets/diamond.png");
  background-size: cover;
}

.favorite_off {
  width: 22px;
  height: 22px;
  background: url("../assets/favorite_off.png");
  background-size: cover;
}

.favorite_on {
  width: 22px;
  height: 22px;
  background: url("../assets/favorite_on.png");
  background-size: cover;
}

</style>
